<template>
    <div :class="$style.errorsInApp">
        <div :class="$style.container">
            <div
                class="text-dark font-size-30"
                :class="$style.info"
            >
                <div class="font-weight-bold mb-3">
                    🐛 Error interno
                </div>
                <div>{{ text }}</div>
                <div class="font-weight-bold font-size-70">
                    500 —
                </div>
            </div>
            <span :class="$style.bgEmoji">💣</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Error500',
    data() {
        return {
            text: 'Ocurrió un evento inesperado. Si crees que se trata de un error puedes comunicárnoslo.'
        };
    },
    beforeMount() {
        if (this.$route.query.error) {
            this.text = this.$route.query.error;
        }
    }
};
</script>
<style lang="scss" module>
@import './style.scss';
</style>
